import { createFileRoute } from '@tanstack/react-router'
import { BackgroundCheckUso } from '@/features/background-check/uso'
import { requireBcAdmin } from '@/lib/route-guards'

export const Route = createFileRoute('/_authenticated/background-check/uso/')({
  beforeLoad: async () => {
    await requireBcAdmin()
  },
  component: BackgroundCheckUso,
})
